var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{attrs:{"show":!_vm.loaded,"rounded":"lg"}},[_c('b-card',[_c('maps',{key:"officerMap",attrs:{"loaded":_vm.loaded,"officers":_vm.officers,"assetTypes":_vm.assetTypes,"assets":_vm.assets,"roles":_vm.roles}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }